import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import LoginPage from './pages/LoginPage'
import UserDashboard from './pages/UserDashboard'
import AdminDashboard from './pages/AdminDashboard'
import ViewerDashboard from './pages/ViewerDashboard'
import ChangePasswordPage from './pages/ChangePasswordPage'
import BrechasTestPage from './pages/BrechasTestPage'
import CicloPDCAPage from './pages/CicloPDCAPage'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'

function App() {
  const { user } = useAuthStore()

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={
        user ? (
          <Navigate to={
            user.rol === 'admin' ? '/admin' : 
            user.rol === 'visualizador' ? '/viewer' : 
            '/dashboard'
          } replace />
        ) : (
          <Navigate to="/login" replace />
        )
      } />
      
      <Route element={<Layout />}>
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={['usuario']}>
            <UserDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/admin" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/viewer" element={
          <ProtectedRoute allowedRoles={['visualizador']}>
            <ViewerDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/change-password" element={
          <ProtectedRoute allowedRoles={['usuario', 'admin', 'visualizador']}>
            <ChangePasswordPage />
          </ProtectedRoute>
        } />
        
        <Route path="/brechas-test" element={
          <ProtectedRoute allowedRoles={['usuario', 'admin', 'visualizador']}>
            <BrechasTestPage />
          </ProtectedRoute>
        } />
        
        <Route path="/ciclos/:cicloId" element={
          <ProtectedRoute allowedRoles={['usuario', 'admin']}>
            <CicloPDCAPage />
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
  )
}

export default App